export default "__VITE_PUBLIC_ASSET__245cc9b3__"